/* @flow */
import type {Action} from "../action";

const DefaultState = {
  enabled: false, // This may be set to true
  queue: []
};

const DisabledState = {
  enabled: false,  // This mustn't be set to true
  queue: []
};

function addSoundToQueue(state, action) {
  if (!state.enabled) return DisabledState;

  let newState = Object.assign({}, state, { queue: [...state.queue] });
  const shouldAdd = newState.queue.reduce((shouldAdd, sound) => {
    if (!shouldAdd) return false;

    // Do not add new sound into the queue if there's already the same sound
    if (sound.type === action.type) {
      return false;
    }

    return shouldAdd;
  }, true);

  if (shouldAdd) {
    newState.queue.push({
      type: action.type,
      id: action.id
    });

    return newState;
  }

  return state;

}

function removeSoundFromQueue(state, payload) {
  if (!state.enabled) return DisabledState;

  let newState = Object.assign({}, state, { queue: [...state.queue] });
  const index = newState.queue.findIndex(item => item.id === payload);

  if (index > -1) {
    newState.queue.splice(index, 1);
  }

  return newState;
}

function processSettingsUpdate(state, settings) {
  if (settings.sound !== undefined) {
    // Reset queue on settings change
    return {
      enabled: settings.sound,
      queue: []
    };
  }

  return state;
}

type QueueItem = {
  type: "PLAY_WIN_SOUND" | "PLAY_LOOSE_SOUND",
  id: number // Use timestamp to identify sounds
};

type State = {
  enabled: boolean,
  queue: Array<QueueItem>
};

function audio(state: State = DefaultState, action: Action): State {
  switch (action.type) {
    case "PLAY_WIN_SOUND":
    case "PLAY_LOOSE_SOUND":
      return addSoundToQueue(state, action);
    case "REMOVE_SOUND":
      return removeSoundFromQueue(state, action.payload);
    case "RECEIVE_SETTINGS":
    case "UPDATE_SETTINGS":
      return processSettingsUpdate(state, action.payload);
    default:
      return state;
  }
}

export default audio;



// WEBPACK FOOTER //
// ./src/redux/reducer/audio.js